/**
 * Signs up a new user.
 *
 * @param {string} token **Required** The token issued to the user.
 * @param {string} connection The connection type (e.g. "google", "email"). Default email.
 * @param {string} password **Required if connection=email** The user's password.
 * @param {string} firstName The user's first name (optional).
 * @param {string} lastName The user's last name (optional).
 *
 * @returns {object} The user's data or { error: "message"}.
 */

export default async function signup(data) {
    let { token, password, jobTitle, email, schoolName } = data;
  
    const body = {
      token,
      password,
      email,
      jobTitle,
      schoolName,
    };
  
    const response = await fetch('/auth/register/emailpswd', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  
    // if we received an error response, return the message
    if (!response.ok) {
      // return the error message
      const { message } = await response.json();
      console.error(`Signup failed. ${message}`);
      return {
        error: message,
      };
    }
  
    return await response.json();
  };
  